import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return { icon: 'ri-arrow-up-line', color: 'text-accent-500' };
    if (trend === 'down') return { icon: 'ri-arrow-down-line', color: 'text-secondary-500' };
    return { icon: 'ri-subtract-line', color: 'text-foreground-400' };
  };

  const getRankBadge = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-primary-500 text-background-50';
    if (rank === 3) return 'bg-secondary-500 text-background-50';
    return 'bg-background-200 text-foreground-500';
  };

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            热度榜单
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            人气排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            实时热度排名，发现全网最受欢迎的漫画
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 border border-background-200 rounded-xl overflow-hidden">
          {rankingItems.map((item, idx) => {
            const trendInfo = getTrendIcon(item.trend);
            return (
              <div
                key={item.id}
                className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-100' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankBadge(item.rank)}`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">{item.title}</h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.category}</p>
                </div>
                <div className="flex items-center gap-4 flex-shrink-0">
                  <span className="text-sm font-medium text-accent-600 whitespace-nowrap">{item.heat}</span>
                  <span className={`${trendInfo.color}`}>
                    <i className={`${trendInfo.icon} text-sm`}></i>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}